export function clearApiCache() {
    return caches.delete('api-cache')
}
